import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Card } from "../common/card/card";
import { Button as MuiButton, Grid, CircularProgress } from "@material-ui/core";
import { useWorkOrderStyles, Caption, Value, CardTitle, ValueMultiLined } from "./workOrderDetails";
import SKUList from "./skuList";
import { STATUSES } from "../../globals/workOrderStatus";
import BellAndContractorComments from "./BellAndContractorComments";
import moment from "moment";
import { useLocalizedName } from "../../globals/langHelpers";
import { disableBellToSendButton } from "../../redux/task/taskActions";

const disableEditStatuses = [STATUSES.BELL_BILLING_APPROVAL, STATUSES.CANCELLED];
const skuEditableStatus = [STATUSES.PENDING_REVIEW, STATUSES.BILLING_ADJUSTMENT];

const getFormattedDate = (assignDate, separator = "/") => {
    if (assignDate === null || assignDate === undefined) return "";

    if (assignDate instanceof moment) return moment(new Date(assignDate)).utc().format("MMM DD, YYYY");
    return moment(assignDate).utc().format("MMM DD, YYYY");
};

const CostInformation = (props) => {
    const { workorderData, purchaseOrderNumber, relatedIdInformation } = props;
    const { getLocalizedName } = useLocalizedName();
    const classes = useWorkOrderStyles();
    const dispatch = useDispatch();
    const [editSKUs, setEditSKUs] = useState(false);
    const readOnly = workorderData?.status === undefined || disableEditStatuses.includes(workorderData?.status?.id);
    const skuListEditable = workorderData?.status ? skuEditableStatus?.includes(workorderData?.status?.id) : false;
    const followups = relatedIdInformation?.followUps?.results
        ?.filter((followup) => followup.isFollowUpActive)
        .map((followup) => getLocalizedName({ object: followup?.followUpTpyeId }));
    const dateFormatter = (iDate) => {
        return iDate ? moment.utc(new Date(iDate)).format("MMM DD, YYYY") : null;
    };
    const handleSKUSave = () => {
        setEditSKUs(false);
    };

    const handleCancel = () => {
        setEditSKUs(false);
    };
    const getFormatedDate = (date) => {
        return date ? moment.utc(date).local().format("MMMM DD, YYYY") : "";
    };

    return (
        <div>
            {relatedIdInformation?.tasks?.resourceAssignedTo || relatedIdInformation?.tasks?.resourceAssignedTo === null ? (
                <>
                    <Card>
                        <CardTitle>
                            <FormattedMessage
                                id="admin.work-order-details.cost-info.billing-details-title"
                                defaultMessage="Billing details"
                                description="Admin work order billing details title"
                            />
                        </CardTitle>
                        <Grid container className={classes.row}>
                            <Grid item xs={2}>
                                <Caption>
                                    <FormattedMessage
                                        id="admin.work-order-details.cost-info.completed-by-caption"
                                        defaultMessage="Completed by"
                                        description="Admin work order billing details completed by"
                                    />
                                </Caption>
                                <ValueMultiLined>
                                    {relatedIdInformation?.tasks?.resourceAssignedTo && relatedIdInformation?.tasks?.resourceAssignedTo?.firstName}
                                    {relatedIdInformation?.tasks?.resourceAssignedTo && relatedIdInformation?.tasks?.resourceAssignedTo?.lastName}
                                </ValueMultiLined>
                            </Grid>
                            <Grid item xs={2}>
                                <Caption>
                                    <FormattedMessage
                                        id="admin.work-order-details.cost-info.billing-submitted-caption"
                                        defaultMessage="Billing submitted"
                                        description="Admin work order billing details billing submitted"
                                    />
                                </Caption>
                                <Value>{getFormatedDate(workorderData?.billingSubmittedDate)}</Value>
                            </Grid>
                            <Grid item xs={2}>
                                <Caption>
                                    <FormattedMessage
                                        id="admin.work-order-details.cost-info.billing-completed-caption"
                                        defaultMessage="Billing completed"
                                        description="Admin work order billing details billing completed"
                                    />
                                </Caption>
                                <Value>{getFormatedDate(workorderData?.billingCompletedDate)}</Value>
                            </Grid>
                            <Grid item xs={2}>
                                <Caption>
                                    <FormattedMessage
                                        id="admin.work-order-details.cost-info.wo-completed-caption"
                                        defaultMessage="WO completed"
                                        description="Admin work order billing details WO completed"
                                    />
                                </Caption>
                                <Value>{dateFormatter(relatedIdInformation?.tasks?.completionDate)} </Value>
                            </Grid>
                            <Grid item xs={2}>
                                <Caption>
                                    <FormattedMessage
                                        id="admin.work-order-details.cost-info.132-sent-caption"
                                        defaultMessage="132 sent"
                                        description="Admin work order billing details 132 sent"
                                    />
                                </Caption>
                                <Value>
                                    {getFormattedDate(
                                        relatedIdInformation?.sapWorkOrderPOList?.results[0]?.sapPurchaseOrder?.requestTime
                                            ? relatedIdInformation?.sapWorkOrderPOList?.results[0]?.sapPurchaseOrder?.requestTime
                                            : relatedIdInformation?.billingList?.results[0]?.excelProcessedDate,
                                    )}
                                </Value>
                            </Grid>
                        </Grid>
                        <Grid container className={classes.row}>
                            <Grid item xs={10}>
                                <Caption>
                                    <FormattedMessage
                                        id="admin.work-order-details.cost-info.wo-po-number"
                                        defaultMessage="PO#"
                                        description="Admin work order billing details PO#"
                                    />
                                </Caption>
                                <Value>{purchaseOrderNumber}</Value>
                            </Grid>
                        </Grid>
                    </Card>
                    {getLocalizedName({ object: workorderData?.completionCode }) && (
                        <Card>
                            <CardTitle>
                                <FormattedMessage
                                    id="admin.workorder-details.completeDetails"
                                    defaultMessage="Completion details"
                                    description="Completion details label"
                                />
                            </CardTitle>
                            <Grid container className={classes.row}>
                                <Grid item xs={4}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.workorder-details.completionCode"
                                            defaultMessage="Completion Code"
                                            description="Completion Code label"
                                        />
                                    </Caption>
                                    <Value>{getLocalizedName({ object: workorderData?.completionCode })}</Value>
                                </Grid>
                                <Grid item xs={4}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.workorder-details.completeDate"
                                            defaultMessage="Completion date"
                                            description="Completion date label"
                                        />
                                    </Caption>
                                    <Value>{dateFormatter(relatedIdInformation?.tasks?.completionDate)}</Value>
                                </Grid>
                                <Grid item xs={4}>
                                    <Caption>
                                        <FormattedMessage id="wo-actions.follow-ups.title" defaultMessage="Follow-Up" description="Follow-up label" />
                                    </Caption>
                                    <Value>{followups?.join("; ")}</Value>
                                </Grid>
                            </Grid>
                        </Card>
                    )}
                    <Card>
                        <CardTitle>
                            <FormattedMessage
                                id="admin.work-order-details.cost-info.comments-title"
                                defaultMessage="Comments"
                                description="Admin work order comments title"
                            />
                        </CardTitle>
                        <BellAndContractorComments
                            workorderData={workorderData}
                            contractorComment={workorderData?.contractorComments}
                            readOnly={readOnly}
                        />
                    </Card>
                    <div className={classes.skuContainer}>
                        <Grid container>
                            <Grid item xs={12}>
                                <>
                                    <CardTitle>
                                        <FormattedMessage
                                            id="admin.work-order-details.cost-info.sku-list-title"
                                            defaultMessage="SKU list"
                                            description="Admin work order SKU list title"
                                        />
                                    </CardTitle>
                                    {editSKUs || (
                                        <MuiButton
                                            className="no-print"
                                            disabled={!skuListEditable}
                                            onClick={() => (setEditSKUs(true), dispatch(disableBellToSendButton(true)))}>
                                            <FormattedMessage
                                                id="admin.work-order-details.edit"
                                                defaultMessage="Edit"
                                                description="Admin work order edit button"
                                            />
                                        </MuiButton>
                                    )}
                                </>
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            style={{
                                zIndex: 1,
                            }}>
                            <Grid
                                item
                                xs={12}
                                style={{
                                    zIndex: 1,
                                }}>
                                <SKUList
                                    workorderData={workorderData}
                                    relatedIdInformation={relatedIdInformation}
                                    edit={editSKUs}
                                    woSkuList={relatedIdInformation?.tasks?.skuList?.results ? relatedIdInformation?.tasks?.skuList?.results : []}
                                    onSave={handleSKUSave}
                                    onClose={handleCancel}
                                    disableBellToSendButton={disableBellToSendButton}
                                />
                            </Grid>
                        </Grid>
                    </div>
                    <div className={classes.footerStyle} />
                </>
            ) : (
                <div className={classes.spinner}>
                    <CircularProgress />
                </div>
            )}
        </div>
    );
};

export default CostInformation;
